import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';

type IExposedProps = {
    show: boolean;
    handleClose: () => void;
    handleSubmit?: () => void;
    header: string;
    body: string;
    submitText?: string;
    closeText?: string;
}

class DefaultPromptModal extends React.Component<IExposedProps, {}>{
    constructor(props: IExposedProps) {
        super(props);
    }

    render() {
        return (
            <Dialog open={this.props.show} onClose={this.props.handleClose}>
                <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white', pr: 6 }}>
                    {this.props.header}
                    <IconButton onClick={this.props.handleClose} size="small" sx={{ position: 'absolute', right: 8, top: 8, color: 'white' }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    <p>{this.props.body}</p>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    {this.props.submitText && this.props.handleSubmit &&
                        <Button variant="contained" color="primary" onClick={this.props.handleSubmit}>
                            {this.props.submitText}
                        </Button>
                    }
                    {this.props.closeText &&
                        <Button variant="outlined" color="inherit" onClick={this.props.handleClose}>
                            {this.props.closeText}
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

export default DefaultPromptModal;
